module.exports = __webpack_public_path__ + "assets/devices/GB-501-b5bb57463badb5ed923f23189a55764f.svg";